export default __webpack_public_path__ + "static/media/zoom-out.65a36fa9.svg";